import { useConfigContext } from "@voxmedia/duet-context/context/config-context";
import { getCoralIdFromNode } from "@voxmedia/duet-utils";

export function useCoralStoryId(args: {
  chorusId?: number | null;
  chorusUuid?: string | null;
  globalId?: string | null;
  nodeId?: string;
}) {
  const { coralConfig } = useConfigContext();

  if (!coralConfig) {
    throw new Error("missing coral config");
  }

  return getCoralIdFromNode(args);
}
